export default {
  en: {
    errorAdditionalProperties: 'Has additional property "{{ property }}" but no additional properties are allowed.',
    errorAnyOf: 'Must validate against at least one of the provided schemas.',
    errorConst: 'Must have value of: {{ const }}.',
    errorContains: 'Must contain at least one item matching the provided schema.',
    errorDependentRequired: 'Must have the required properties: {{ dependentRequired }}.',
    errorEnum: 'Must be one of the enumerated values: {{ enum }}.',
    errorExclusiveMaximum: 'Must be less than {{ exclusiveMaximum }}.',
    errorExclusiveMinimum: 'Must be greater than {{ exclusiveMinimum }}.',
    errorFormat: 'Invalid format: {{ format }}.',
    errorItems: 'Must have items that validate against the provided schema.',
    errorMaximum: 'Must be at most {{ maximum }}.',
    errorMaxItems: 'Must have at most {{ maxItems }} items.',
    errorMaxLength: 'Must be at most {{ maxLength }} characters long.',
    errorMaxProperties: 'Must have at most {{ maxProperties }} properties.',
    errorMaxContains: 'Must contain at most {{ maxContains }} items matching the provided schema. It currently contains {{ counter }}.',
    errorMinContains: 'Must contain at least {{ minContains }} items matching the provided schema. It currently contains {{ counter }}.',
    errorMinimum: 'Must be at least {{ minimum }}.',
    errorMinItems: 'Must have at least {{ minItems }} items.',
    errorMinLength: 'Must be at least {{ minLength }} characters long.',
    errorMinProperties: 'Must have at least {{ minProperties }} properties.',
    errorMultipleOf: 'Must be multiple of {{ multipleOf }}.',
    errorNot: 'Must not validate against the provided schema.',
    errorOneOf: 'Must validate against exactly one of the provided schemas. It currently validates against {{ counter }} of the schemas.',
    errorPattern: 'Must match the pattern: "{{ pattern }}".',
    errorPrefixItems: 'Item {{ index }} fails validation.',
    errorPropertyNames: 'Property name "{{ propertyName }}" fails validation.',
    errorProperties: 'The following properties do not comply with their schemas: {{ properties }}',
    errorRequired: 'Must have the required properties: {{ required }}.',
    errorType: 'Must be of type {{ type }}.',
    errorUnevaluatedProperties: 'Has invalid unevaluated property "{{ property }}"',
    errorUniqueItems: 'Must have unique items.',
    arrayDelete: 'Delete item',
    arrayMoveUp: 'Move up',
    arrayMoveDown: 'Move down',
    arrayDrag: 'Drag',
    arrayAdd: 'Add item',
    arrayConfirmDelete: 'Are you sure you want to delete this item?',
    arrayDeleteAll: 'Delete all items',
    arrayConfirmDeleteAll: 'Are you sure you want to delete all items?',
    objectAddProperty: 'Add property',
    objectPropertyAdded: 'field was added to the form',
    objectPropertyRemoved: 'field was removed from the form',
    propertiesToggle: 'Properties',
    collapseToggle: 'Collapse'
  },
  de: {
    errorAdditionalProperties: 'Hat die zusätzliche Eigenschaft "{{ property }}", aber keine zusätzlichen Eigenschaften sind erlaubt.',
    errorAnyOf: 'Muss mindestens einem der bereitgestellten Schemata entsprechen.',
    errorConst: 'Muss den Wert {{ const }} haben.',
    errorContains: 'Muss mindestens ein Element enthalten, das dem bereitgestellten Schema entspricht.',
    errorDependentRequired: 'Muss die erforderlichen Eigenschaften haben: {{ dependentRequired }}.',
    errorEnum: 'Muss einer der aufgeführten Werte sein: {{ enum }}.',
    errorExclusiveMaximum: 'Muss kleiner als {{ exclusiveMaximum }} sein.',
    errorExclusiveMinimum: 'Muss größer als {{ exclusiveMinimum }} sein.',
    errorFormat: 'Ungültiges Format: {{ format }}.',
    errorItems: 'Muss Elemente enthalten, die dem bereitgestellten Schema entsprechen.',
    errorMaximum: 'Darf höchstens {{ maximum }} sein.',
    errorMaxItems: 'Darf höchstens {{ maxItems }} Elemente enthalten.',
    errorMaxLength: 'Darf höchstens {{ maxLength }} Zeichen lang sein.',
    errorMaxProperties: 'Darf höchstens {{ maxProperties }} Eigenschaften haben.',
    errorMaxContains: 'Darf höchstens {{ maxContains }} Elemente enthalten, die dem bereitgestellten Schema entsprechen. Aktuell enthält es {{ counter }}.',
    errorMinContains: 'Muss mindestens {{ minContains }} Elemente enthalten, die dem bereitgestellten Schema entsprechen. Aktuell enthält es {{ counter }}.',
    errorMinimum: 'Muss mindestens {{ minimum }} sein.',
    errorMinItems: 'Muss mindestens {{ minItems }} Elemente enthalten.',
    errorMinLength: 'Muss mindestens {{ minLength }} Zeichen lang sein.',
    errorMinProperties: 'Muss mindestens {{ minProperties }} Eigenschaften haben.',
    errorMultipleOf: 'Muss ein Vielfaches von {{ multipleOf }} sein.',
    errorNot: 'Darf nicht dem bereitgestellten Schema entsprechen.',
    errorOneOf: 'Muss genau einem der bereitgestellten Schemata entsprechen. Derzeit entspricht es {{ counter }} der Schemata.',
    errorPattern: 'Muss dem Muster "{{ pattern }}" entsprechen.',
    errorPrefixItems: 'Element {{ index }} entspricht nicht der Validierung.',
    errorPropertyNames: 'Der Eigenschaftsname "{{ propertyName }}" entspricht nicht der Validierung.',
    errorProperties: 'Die folgenden Eigenschaften entsprechen nicht ihren Schemata: {{ properties }}',
    errorRequired: 'Muss die erforderlichen Eigenschaften haben: {{ required }}.',
    errorType: 'Muss vom Typ {{ type }} sein.',
    errorUnevaluatedProperties: 'Hat eine ungültige nicht bewertete Eigenschaft "{{ property }}"',
    errorUniqueItems: 'Muss eindeutige Elemente haben.',
    arrayDelete: 'Element löschen',
    arrayMoveUp: 'Nach oben verschieben',
    arrayMoveDown: 'Nach unten verschieben',
    arrayDrag: 'Ziehen',
    arrayAdd: 'Element hinzufügen',
    arrayConfirmDelete: 'Möchten Sie dieses Element wirklich löschen?',
    arrayDeleteAll: 'Alle Elemente löschen',
    arrayConfirmDeleteAll: 'Möchten Sie wirklich alle Elemente löschen?',
    objectAddProperty: 'Eigenschaft hinzufügen',
    objectPropertyAdded: 'Feld wurde dem Formular hinzugefügt',
    objectPropertyRemoved: 'Feld wurde aus dem Formular entfernt',
    propertiesToggle: 'Eigenschaften',
    collapseToggle: 'Einklappen'
  },
  it: {
    errorAdditionalProperties: 'Ha la proprietà aggiuntiva "{{ property }}" ma non sono consentite proprietà aggiuntive.',
    errorAnyOf: 'Deve rispettare almeno uno degli schemi forniti.',
    errorConst: 'Deve avere il valore: {{ const }}.',
    errorContains: 'Deve contenere almeno un elemento che rispetti lo schema fornito.',
    errorDependentRequired: 'Deve avere le proprietà richieste: {{ dependentRequired }}.',
    errorEnum: 'Deve essere uno dei valori elencati: {{ enum }}.',
    errorExclusiveMaximum: 'Deve essere inferiore a {{ exclusiveMaximum }}.',
    errorExclusiveMinimum: 'Deve essere maggiore di {{ exclusiveMinimum }}.',
    errorFormat: 'Formato non valido: {{ format }}.',
    errorItems: 'Deve avere elementi che rispettano lo schema fornito.',
    errorMaximum: 'Deve essere al massimo {{ maximum }}.',
    errorMaxItems: 'Deve avere al massimo {{ maxItems }} elementi.',
    errorMaxLength: 'Deve avere al massimo {{ maxLength }} caratteri.',
    errorMaxProperties: 'Deve avere al massimo {{ maxProperties }} proprietà.',
    errorMaxContains: 'Deve contenere al massimo {{ maxContains }} elementi che rispettano lo schema fornito. Attualmente ne contiene {{ counter }}.',
    errorMinContains: 'Deve contenere almeno {{ minContains }} elementi che rispettano lo schema fornito. Attualmente ne contiene {{ counter }}.',
    errorMinimum: 'Deve essere almeno {{ minimum }}.',
    errorMinItems: 'Deve avere almeno {{ minItems }} elementi.',
    errorMinLength: 'Deve avere almeno {{ minLength }} caratteri.',
    errorMinProperties: 'Deve avere almeno {{ minProperties }} proprietà.',
    errorMultipleOf: 'Deve essere un multiplo di {{ multipleOf }}.',
    errorNot: 'Non deve rispettare lo schema fornito.',
    errorOneOf: 'Deve rispettare esattamente uno degli schemi forniti. Attualmente rispetta {{ counter }} degli schemi.',
    errorPattern: 'Deve rispettare il modello: "{{ pattern }}".',
    errorPrefixItems: 'L\'elemento {{ index }} non è valido.',
    errorPropertyNames: 'Il nome della proprietà "{{ propertyName }}" non è valido.',
    errorProperties: 'Le seguenti proprietà non rispettano i loro schemi: {{ properties }}',
    errorRequired: 'Deve avere le proprietà richieste: {{ required }}.',
    errorType: 'Deve essere di tipo {{ type }}.',
    errorUnevaluatedProperties: 'Ha una proprietà non valutata non valida "{{ property }}"',
    errorUniqueItems: 'Deve avere elementi univoci.',
    arrayDelete: 'Elimina elemento',
    arrayMoveUp: 'Sposta su',
    arrayMoveDown: 'Sposta giù',
    arrayDrag: 'Trascina',
    arrayAdd: 'Aggiungi elemento',
    arrayConfirmDelete: 'Sei sicuro di voler eliminare questo elemento?',
    arrayDeleteAll: 'Elimina tutti gli elementi',
    arrayConfirmDeleteAll: 'Sei sicuro di voler eliminare tutti gli elementi?',
    objectAddProperty: 'Aggiungi proprietà',
    objectPropertyAdded: 'Campo aggiunto al modulo',
    objectPropertyRemoved: 'Campo rimosso dal modulo',
    propertiesToggle: 'Proprietà',
    collapseToggle: 'Comprimi'
  },
  es: {
    errorAdditionalProperties: 'Tiene la propiedad adicional "{{ property }}" pero no se permiten propiedades adicionales.',
    errorAnyOf: 'Debe cumplir con al menos uno de los esquemas proporcionados.',
    errorConst: 'Debe tener el valor: {{ const }}.',
    errorContains: 'Debe contener al menos un elemento que cumpla con el esquema proporcionado.',
    errorDependentRequired: 'Debe tener las propiedades requeridas: {{ dependentRequired }}.',
    errorEnum: 'Debe ser uno de los valores enumerados: {{ enum }}.',
    errorExclusiveMaximum: 'Debe ser menor que {{ exclusiveMaximum }}.',
    errorExclusiveMinimum: 'Debe ser mayor que {{ exclusiveMinimum }}.',
    errorFormat: 'Formato no válido: {{ format }}.',
    errorItems: 'Debe tener elementos que cumplan con el esquema proporcionado.',
    errorMaximum: 'Debe ser como máximo {{ maximum }}.',
    errorMaxItems: 'Debe tener como máximo {{ maxItems }} elementos.',
    errorMaxLength: 'Debe tener como máximo {{ maxLength }} caracteres.',
    errorMaxProperties: 'Debe tener como máximo {{ maxProperties }} propiedades.',
    errorMaxContains: 'Debe contener como máximo {{ maxContains }} elementos que cumplan con el esquema proporcionado. Actualmente contiene {{ counter }}.',
    errorMinContains: 'Debe contener al menos {{ minContains }} elementos que cumplan con el esquema proporcionado. Actualmente contiene {{ counter }}.',
    errorMinimum: 'Debe ser al menos {{ minimum }}.',
    errorMinItems: 'Debe tener al menos {{ minItems }} elementos.',
    errorMinLength: 'Debe tener al menos {{ minLength }} caracteres.',
    errorMinProperties: 'Debe tener al menos {{ minProperties }} propiedades.',
    errorMultipleOf: 'Debe ser múltiplo de {{ multipleOf }}.',
    errorNot: 'No debe cumplir con el esquema proporcionado.',
    errorOneOf: 'Debe cumplir con exactamente uno de los esquemas proporcionados. Actualmente cumple con {{ counter }} de los esquemas.',
    errorPattern: 'Debe coincidir con el patrón: "{{ pattern }}".',
    errorPrefixItems: 'El elemento {{ index }} no es válido.',
    errorPropertyNames: 'El nombre de la propiedad "{{ propertyName }}" no es válido.',
    errorProperties: 'Las siguientes propiedades no cumplen con sus esquemas: {{ properties }}',
    errorRequired: 'Debe tener las propiedades requeridas: {{ required }}.',
    errorType: 'Debe ser del tipo {{ type }}.',
    errorUnevaluatedProperties: 'Tiene una propiedad no evaluada no válida "{{ property }}"',
    errorUniqueItems: 'Debe tener elementos únicos.',
    arrayDelete: 'Eliminar elemento',
    arrayMoveUp: 'Mover hacia arriba',
    arrayMoveDown: 'Mover hacia abajo',
    arrayDrag: 'Arrastrar',
    arrayAdd: 'Agregar elemento',
    arrayConfirmDelete: '¿Estás seguro de que deseas eliminar este elemento?',
    arrayDeleteAll: 'Eliminar todos los elementos',
    arrayConfirmDeleteAll: '¿Está seguro de que desea eliminar todos los elementos?',
    objectAddProperty: 'Agregar propiedad',
    objectPropertyAdded: 'campo fue añadido al formulario',
    objectPropertyRemoved: 'campo fue eliminado del formulario',
    propertiesToggle: 'Propiedades',
    collapseToggle: 'Colapsar'
  }
}
